/**
 * Created by jv on 14/02/2017.
 */
const utils = require("Sources/utils/utils");
const Tooltip = require("Sources/components/tooltip");
const FormGroupTemplate = require("Sources/templates/form-group.template");

//styles
//...

module.exports = class FormTemplate
{
  constructor(options)
  {
    /*
     * options.formId
     * options.appendTo
     *
     * options.formData (data to make the FormGroupTemplates)
     *
     * options.onRender
     * options.afterRender
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.formId = options.formId;
    this.appendTo = $(options.appendTo);

    this.title = options.title;
    this.titleTooltipTitle = options.titleTooltipTitle;
    this.titleTooltipText = options.titleTooltipText;

    this.formData = options.formData;

    this.onRender = utils.isFunction(options.onRender) ? options.onRender : null;
    this.afterRender = utils.isFunction(options.afterRender) ? options.afterRender : null;

    this.formWrapperEl = null;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.rerender();

      this._initialized = true;
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length)
    {
      this.formWrapperEl.remove();
    }

    this._initialized = false;
  }

  show()
  {
    if(utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length)
    {
      this.formWrapperEl.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length)
    {
      this.formWrapperEl.hide();
    }
  }

  rerender()
  {
    this.renderFormWrapper();
  }

  reset()
  {
    for(var i = 0; i < this.formGroups.length; i++)
    {
      this.formGroups[i].reset();
    }
  }

  getFormGroupByKey(key)
  {
    for(let i = 0; i < this.formGroups.length; i++)
    {
      if (this.formGroups[i].key === key)
        return this.formGroups[i];
    }

    return null;
  }

  validate()
  {
    var formValid = true;

    for(var i = 0; i < this.formGroups.length; i++)
    {
      if(!this.formGroups[i].validate())
      {
        formValid = false;
      }
    }

    if(!formValid)
    {
      //Do something?
    }

    return formValid;
  }

  renderFormWrapper()
  {
    if(utils.isNotNull(this.formWrapperEl) && this.formWrapperEl.length)
    {
      this.formWrapperEl.remove();
    }

    this.formWrapperEl = $("<div class='form-wrapper clearfix'></div>");

    if(utils.isNotNull(this.title))
    {
      var formTitleWrapper = $("<div class='clearfix'></div>");

      formTitleWrapper.append("<h4 class='form-title'>" + this.title + "</h4>");

      if(utils.isNotNull(this.titleTooltipText))
      {
        var tooltipBtn = $("<button type='button' class='btn btn-icon frameless question-circle'></button>")
        formTitleWrapper.append(tooltipBtn);

        Tooltip.create({
          selector: tooltipBtn,
          title: this.titleTooltipTitle,
          content: this.titleTooltipText
        });
      }

      this.formWrapperEl.append(formTitleWrapper);
    }

    if(!utils.isNullOrEmpty(this.formId))
    {
      this.formWrapperEl.attr("id", this.formId);
    }

    this.formGroups = [];

    for(var i = 0; i < this.formData.length; i++)
    {
      var fData = this.formData[i];
      fData.appendTo = this.formWrapperEl;

      this.formGroups.push(new FormGroupTemplate(fData));
    }

    this.appendTo.append(this.formWrapperEl);
  }

  getDataObject()
  {
    var data = {};

    for(var i = 0; i < this.formGroups.length; i++)
    {
      if(!this.formGroups.disabled)
      {
        if(utils.isNotNull(this.formGroups[i].dataGroup))
        {
          if(!data.hasOwnProperty(this.formGroups[i].dataGroup))
          {
            data[this.formGroups[i].dataGroup] = {};
          }

          data[this.formGroups[i].dataGroup][this.formGroups[i].key] = this.formGroups[i].value;
        }
        else
        {
          data[this.formGroups[i].key] = this.formGroups[i].value;
        }
      }
    }

    return data;
  }

  getFormGroupForKey(key)
  {
    if(utils.isArray(this.formGroups))
    {
      for(var i = 0; i < this.formGroups.length; i++)
      {
        if(this.formGroups[i].key === key)
        {
          return this.formGroups[i];
        }
      }
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./app/js/templates/form.template.js